export const Legend = () => null;

Legend['displayName'] = 'MultiMeterBarChart.Legend';
